import { mapGetters } from 'vuex';
import DeforestationService from '@/_services/DeforestationService';
// import { PERMISSIONS } from '@/constants/permissions';

export default {
  computed: {
    ...mapGetters(['getUser', 'getUserRoles']),
    ...mapGetters('eudrDDS', ['isEditModeEnabled']),

    /**
     * Determines if the current page should be in readonly mode
     * @returns {boolean} True if page should be readonly
     */
    isReadonlyMode() {
      const user = JSON.parse(localStorage.getItem('user'));
      let isKenyaOrPtsiClient = false;
      if(user){
        isKenyaOrPtsiClient = user?.user_role_assoc?.some(role => 
          role.id === 'indonesia_admin' || role.id === 'naccu_kenya_admin'
        );
      }

      // Get the diligence report data to check for assignment and requestAdditionalInformation
      // Try Vuex store first, then fallback to local report data
      let diligenceDetails = this.$store.getters["eudrDDS/getDiligenceDetails"];
      
      // Fallback to local report data if Vuex doesn't have it
      if ((!diligenceDetails || !diligenceDetails.id)) {
        if (this.report && this.report.id) {
          diligenceDetails = this.report;
        } else if (this.reportDetails && this.reportDetails.id) {
          diligenceDetails = this.reportDetails;
        }
      }
      
      console.log("diligenceDetails:", diligenceDetails);
      
      // Check if DDS is assigned to a worker from parent organization
      const isAssignedToWorker = diligenceDetails?.assignedTo && diligenceDetails?.assignedToCfId;
      
      // Check status legends to determine report state
      const statusLegends = diligenceDetails?.statusLegends?.toLowerCase();
      const isPendingApproval = statusLegends === 'pending_approval';
      
      // Determine if there is an OPEN additional information request (pending)
      // Prefer Vuex list; fallback to report details if store list is empty
      let latestAdditionalInfo = this.$store.getters["eudrDDS/ddsAdditionalInformationByDiligenceIdLatest"];
      if (!latestAdditionalInfo && Array.isArray(diligenceDetails?.requestAdditionalInformation) && diligenceDetails.requestAdditionalInformation.length > 0) {
        const sorted = [...diligenceDetails.requestAdditionalInformation].sort((a, b) => (parseInt(b?.id || 0, 10)) - (parseInt(a?.id || 0, 10)));
        latestAdditionalInfo = sorted[0];
      }
      console.log(latestAdditionalInfo, 'latestAdditionalInfo');
      const normalizedStatus = latestAdditionalInfo?.status ? latestAdditionalInfo.status.toString().toLowerCase() : null;
      const hasOpenAdditionalInfo = normalizedStatus === 'pending';
      
      // CRITICAL: Even if Edit Mode is enabled, prevent editing if report is assigned to a worker
      // EXCEPTION: Allow editing if there's an open additional info request (worker requested changes)
      // This ensures that once assigned, the report cannot be edited even if edit mode was enabled
      // UNLESS the worker has requested additional information
      if (isAssignedToWorker && isKenyaOrPtsiClient && !hasOpenAdditionalInfo) {
        return true; // Always readonly if assigned (and no additional info requested), regardless of edit mode
      }
      
      // If Edit Mode is explicitly enabled (from Vuex) and report is NOT assigned, allow editing
      if (this.isEditModeEnabled && !isAssignedToWorker) {
        return false;
      }

      console.log(isAssignedToWorker, 'isAssignedToWorker');
      console.log(hasOpenAdditionalInfo, 'hasOpenAdditionalInfo');
      console.log(isKenyaOrPtsiClient, 'isKenyaOrPtsiClient');
      console.log('statusLegends:', statusLegends);
      console.log('isPendingApproval:', isPendingApproval);

      // If user is NOT Kenya/PTSI, never readonly
      if (!isKenyaOrPtsiClient) {
        return false;
      }
      
      // NEW LOGIC: Report submitted for approval but not yet assigned
      // This is when the supplier clicks "Submit for Approval" but PTSI hasn't assigned it yet
      // In this case, make it readonly (supplier can click Edit Report button to enable editing)
      if (isPendingApproval && !isAssignedToWorker && !hasOpenAdditionalInfo) {
        return true; // Readonly - but can be overridden by Edit Report button
      }
      
      // - Can edit until DDS is assigned to a worker
      // - Once assigned, can only edit if worker requests additional information
      if (isKenyaOrPtsiClient) {
        if (typeof isAssignedToWorker !== 'undefined' && isAssignedToWorker !== null && !isAssignedToWorker) {
          // Not assigned yet - cooperative can edit
          return false;
        } 
        else if(this.$route.name === 'createDueDiligenceReports' && !this.$route.params.show){
          return false; // for create due diligence report page
        }
        else {
          // Assigned to worker - only editable if additional info requested
          return !hasOpenAdditionalInfo;
        }
      }
      

      return false; // default no readonly
      
      // For Kenya/PTSI admin users, editable if either condition below is true
      // const canEdit = (!hasShowParam) || hasRequestAdditionalInfo;
      // return !canEdit;
      
    },

    /**
     * Determines if Edit Report button should be shown
     * Show when: report status is submitted/pending_approval and NOT approved/rejected
     * Button shows regardless of assignment - dialog will handle that
     * @returns {boolean} True if Edit button should be shown
     */
    showEditReportButton() {
      // Try to get from Vuex store first, then fallback to local report prop/data
      let diligenceDetails = this.$store.getters["eudrDDS/getDiligenceDetails"];
      
      // Fallback to local report data if Vuex doesn't have it (for reactivity)
      // Check both 'report' and 'reportDetails' props/data
      if ((!diligenceDetails || !diligenceDetails.id)) {
        if (this.report && this.report.id) {
          diligenceDetails = this.report;
        } else if (this.reportDetails && this.reportDetails.id) {
          diligenceDetails = this.reportDetails;
        }
      }
      
      // Don't show if report doesn't exist (creating new report)
      if (!diligenceDetails || !diligenceDetails.id) {
        return false;
      }
      
      const statusLegends = diligenceDetails?.statusLegends?.toLowerCase();
      const reportStatus = diligenceDetails?.status;
      
      // Only show for Kenya/PTSI clients
      const user = JSON.parse(localStorage.getItem('user'));
      const isKenyaOrPtsiClient = user?.user_role_assoc?.some(role => 
        role.id === 'indonesia_admin' || role.id === 'naccu_kenya_admin'
      );
      
      if (!isKenyaOrPtsiClient) {
        return false;
      }
      
      // Don't show if report is in draft/creation state (statusLegends is null, 'pending', or reportStatus is 'Pending')
      // Only show after report has been explicitly submitted for approval
      // const isDraftState = !statusLegends || 
      //                     statusLegends === 'pending' || 
      //                     reportStatus === 'Pending' || 
      //                     reportStatus === null;
      
      // if (isDraftState) {
      //   return false;
      // }
      
      // Show button when:
      // 1. Report is submitted for approval (statusLegends is specifically 'pending_approval' OR status is 'Under Review')
      // 2. statusLegends is NOT approved or rejected
      // 3. Show even if assigned - the click handler will show restricted dialog if needed
      const isSubmitted = statusLegends === 'pending_approval' || statusLegends === 'pending' || reportStatus === 'Under Review';
      const isApprovedOrRejected = ['approved', 'temporary_approved', 'rejected'].includes(statusLegends);
      
      return isSubmitted && !isApprovedOrRejected;
    },

    /**
     * Check if report is assigned to a worker
     * @returns {boolean} True if report is assigned
     */
    isReportAssignedToWorker() {
      // Try Vuex store first, then fallback to local report data
      let diligenceDetails = this.$store.getters["eudrDDS/getDiligenceDetails"];
      
      // Fallback to local report data if Vuex doesn't have it
      if ((!diligenceDetails || !diligenceDetails.id)) {
        if (this.report && this.report.id) {
          diligenceDetails = this.report;
        } else if (this.reportDetails && this.reportDetails.id) {
          diligenceDetails = this.reportDetails;
        }
      }
      
      return !!(diligenceDetails?.assignedTo && diligenceDetails?.assignedToCfId);
    },

    /**
     * Get readonly props for form components
     * @returns {Object} Props object for readonly state
     */
    readonlyProps() {
      return {
        readonly: this.isReadonlyMode,
        disabled: this.isReadonlyMode
      };
    },

    /**
     * Get readonly attributes for input components
     * @returns {Object} Attributes object for readonly state
     */
    readonlyAttrs() {
      return {
        readonly: this.isReadonlyMode,
        disabled: this.isReadonlyMode
      };
    }
  },

  methods: {
    /**
     * Enable edit mode - allows editing even when report is in readonly state
     * Called when user clicks "Edit Report" button
     */
    async enableEditMode() {
      try {
        // Get report ID from route or store
        const reportId = this.$route?.params?.id || this.diligenceId;
        
        if (reportId) {
          // Update backend to track edit state
          await DeforestationService.updateReportEditStatus(parseInt(reportId), true);
        }
        
        // Update Vuex store
        this.$store.commit('eudrDDS/SET_EDIT_MODE_ENABLED', true);
        
        this.$notify({
          text: this.$t('deforestation.editModeEnabled') || 'Edit mode enabled. You can now edit the report.',
          type: 'success'
        });
      } catch (error) {
        console.error('Failed to enable edit mode:', error);
        this.$notify({
          text: this.$t('deforestation.failedToEnableEditMode') || 'Failed to enable edit mode. Please try again.',
          type: 'error'
        });
      }
    },

    /**
     * Disable edit mode - reverts to readonly state
     */
    async disableEditMode() {
      try {
        // Get report ID from route or store
        const reportId = this.$route?.params?.id || this.diligenceId;
        
        if (reportId) {
          // Update backend to clear edit state
          await DeforestationService.updateReportEditStatus(parseInt(reportId), false);
        }
        
        // Update Vuex store
        this.$store.commit('eudrDDS/SET_EDIT_MODE_ENABLED', false);
      } catch (error) {
        console.error('Failed to disable edit mode:', error);
        // Don't show error notification for disable - it's less critical
      }
    },

    /**
     * Check if a specific field should be readonly
     * @returns {boolean} True if field should be readonly
     */
    isFieldReadonly() {
      return this.isReadonlyMode;
    },

    /**
     * Get readonly state for v-text-field components
     * @returns {Object} Props for v-text-field
     */
    getTextFieldProps() {
      return {
        readonly: this.isReadonlyMode,
        disabled: this.isReadonlyMode,
        outlined: !this.isReadonlyMode,
        filled: this.isReadonlyMode
      };
    },

    /**
     * Get readonly state for v-select components
     * @returns {Object} Props for v-select
     */
    getSelectProps() {
      return {
        readonly: this.isReadonlyMode,
        disabled: this.isReadonlyMode,
        outlined: !this.isReadonlyMode,
        filled: this.isReadonlyMode
      };
    },

    /**
     * Get readonly state for v-textarea components
     * @returns {Object} Props for v-textarea
     */
    getTextareaProps() {
      return {
        readonly: this.isReadonlyMode,
        disabled: this.isReadonlyMode,
        outlined: !this.isReadonlyMode,
        filled: this.isReadonlyMode
      };
    },

    /**
     * Get readonly state for v-checkbox components
     * @returns {Object} Props for v-checkbox
     */
    getCheckboxProps() {
      return {
        disabled: this.isReadonlyMode,
        readonly: this.isReadonlyMode
      };
    },

    /**
     * Get readonly state for v-radio-group components
     * @returns {Object} Props for v-radio-group
     */
    getRadioGroupProps() {
      return {
        disabled: this.isReadonlyMode,
        readonly: this.isReadonlyMode
      };
    },

    /**
     * Get readonly state for v-btn components (save/submit buttons)
     * @returns {Object} Props for v-btn
     */
    getButtonProps() {
      return {
        disabled: this.isReadonlyMode,
        readonly: this.isReadonlyMode
      };
    }
  }
};
